import PazienteHome from "./components/PazienteHome.vue";
export default {
    PazienteHome,
};
